export class TypeEntreprise {
    id: number;
    name: string;
}


